import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RegisterHomeComponent } from './register-home.component';



@NgModule({
  declarations: [RegisterHomeComponent],
  imports: [
    CommonModule
  ]
})
export class RegisterHomeModule { }
